import { useRef } from "react";
import { Container, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com2 = ({ t }) => {
  const ref = useRef();
  useScrollFadeIn(ref);
  return (
    <Wrapper>
      <Container ref={ref}>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/c824e5f1Landing_18.png"
          alt=""
        />
        <div></div>
        <span>{t("2-1")}</span>
        <span>{t("2-2")}</span>
        <span>
          <span>{t("2-3")}</span>
          <span>{t("2-4")}</span>
          <span>{t("2-4-1")}</span>
          <span>{t("2-5")}</span>
        </span>
      </Container>
      <Container>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/02a07b9eLanding_19.png"
          alt=""
        />
        <div></div>
        <span>{t("2-6")}</span>
        <span>{t("2-7")}</span>
        <span>
          <span>{t("2-8")}</span>
          <span>{t("2-9")}</span>
          <span>{t("2-10")}</span>
        </span>
      </Container>
      <Container>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/4becc8f8Landing_20.png"
          alt=""
        />
        <div></div>
        <span>{t("2-11")}</span>
        <span>{t("2-12")}</span>
        <span>
          <span>{t("2-13")}</span>
          <span>{t("2-14")}</span>
          <span>{t("2-15")}</span>
        </span>
      </Container>
      <Container>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/a38b6864Landing_21.png"
          alt=""
        />
        <div></div>
        <span>{t("2-16")}</span>
        <span>{t("2-17")}</span>
        <span>
          <span>{t("2-18")}</span>
          <span>{t("2-19")}</span>
          <span>{t("2-20")}</span>
        </span>
      </Container>
      <Container>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/8fa1533dLanding_22.png"
          alt=""
        />
        <div></div>
        <span>{t("2-21")}</span>
        <span>{t("2-22")}</span>
        <span>
          <span>{t("2-23")}</span>
          <span>{t("2-24")}</span>
          <span>{t("2-25")}</span>
        </span>
      </Container>
    </Wrapper>
  );
};

export default Com2;
